import React from 'react';
import './PayOff.scss';

function PayOff({ onClosePopup }) {
  

  return (
    <div>

    </div>
  );
}

export default PayOff;
